import { Button } from "antd";
import React from "react";
import "./easy-button.scss";

interface EasyButtonProps {
    title: string;
    onClick?: Function;
    className?: string;
    buttonIcon?: React.ReactNode;
}
interface EasyButtonState {
    IsVisibleBookDetail: boolean;
}

class EasyButton extends React.Component<EasyButtonProps, EasyButtonState>{
    constructor(props: any) {
        super(props);
        this.state = {
            IsVisibleBookDetail: false
        };
    }

    onClickHandler = () => {
        if (this.props.onClick) {
            this.props.onClick()
        }
    }

    render() {
        return (
            <div className="easy-button-content">
                <Button
                    onClick={this.onClickHandler}
                    className={`${this.props.className ? `${this.props.className} easy-button` : "easy-button"}`}
                    icon={this.props.buttonIcon ? this.props.buttonIcon : null}
                >
                    {this.props.title}
                </Button>
            </div>
        );
    }
}

export default EasyButton;